import { render, staticRenderFns } from "./AddInvitation.vue?vue&type=template&id=da78d014&scoped=true&"
import script from "./AddInvitation.vue?vue&type=script&lang=js&"
export * from "./AddInvitation.vue?vue&type=script&lang=js&"
import style0 from "./AddInvitation.vue?vue&type=style&index=0&id=da78d014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da78d014",
  null
  
)

export default component.exports